<template>
  <div pr-hold-or-not>
    <template v-if="sect === 'sm' || sect === 'md'">
      <slot />
    </template>
    <template v-else>
      <template v-if="direction === 'b2t'">
        <PrHoldBottom :id="id" :img="img" :title="title" :html="html" :text="text" :direction="direction"
          :position="position">
          <slot name="holdBottom" />
        </PrHoldBottom>
      </template>
      <template v-else>
        <PrHoldRight :id="id" :img="img" :title="title">
          <slot name="holdRight" />
        </PrHoldRight>
      </template>
    </template>
  </div>
</template>

<script>
import PrHoldRight from "@/views/components/PrHoldRight";
import PrHoldBottom from "@/views/components/PrHoldBottom";
export default {
  name: "PrHoldOrNot",
  components: { PrHoldRight, PrHoldBottom },
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "left",
    },
    img: { type: String },
    id: { type: String },
    mobileHeight: { default: "0" },
    direction: { default: "" },
    html: { default: "" },
  },
};
</script>

<style lang="less">
@import "~@/less/proj";

[pr-hold-or-not] {}
</style>
